import type { Meta, StoryObj } from '@storybook/vue3';
import IconText from './IconText.vue';

const meta = {
  title: 'organisms/Icon Text',
  component: IconText,
  tags: ['autodocs'],
  argTypes: {
    headline: { control: 'text' },
    headlineTag: {
      control: 'select',
      options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    },
    headlineSize: {
      control: 'select',
      options: ['small', 'medium', 'large'],
    },
    useRoundIcon: { control: 'boolean' },
    iconTheme: {
      control: 'select',
      options: ['dark', 'light'],
    },
    iconSize: {
      control: 'select',
      options: ['small', 'medium', 'large'],
    },
    svgSize: {
      control: 'select',
      options: ['small', 'medium', 'large'],
    },
    listTag: {
      control: 'select',
      options: ['div', 'ul'],
    },
    listClass: { control: 'text' },
    itemTheme: {
      control: 'select',
      options: ['light', 'dark'],
    },
  },
} satisfies Meta<typeof IconText>;

export default meta;
type Story = StoryObj<typeof meta>;

export const WithHeadlineAndRoundIcons: Story = {
  args: {
    headline: 'Deine Vorteile bei E WIE EINFACH',
    headlineTag: 'h2',
    headlineSize: 'medium',
    useRoundIcon: true,
    iconTheme: 'dark',
    iconSize: 'small',
    listTag: 'div',
    items: [
      {
        icon: 'leaf',
        title: 'Nachhaltig',
        paragraph: '100% Ökostrom und CO2 kompensiertes Gas.',
      },
      {
        icon: 'leaf',
        title: 'Qualität',
        paragraph: 'Ausgezeichneter Service und Kundenzufriedenheit.',
      },
      {
        icon: 'leaf',
        title: 'Sicherheit',
        paragraph: 'Zuverlässige Versorgung zu fairen Preisen.',
      },
      {
        icon: 'leaf',
        title: 'Regional',
        paragraph: 'Unterstützung lokaler Projekte und Gemeinschaften.',
      },
    ],
  },
};

export const WithoutHeadlineAndSvgIcons: Story = {
  args: {
    headline: '',
    useRoundIcon: false,
    listTag: 'ul',
    items: [
      {
        icon: 'check',
        paragraph: 'Keine versteckten Kosten oder Gebühren',
      },
      {
        icon: 'check',
        paragraph: 'Flexible Vertragslaufzeiten',
      },
      {
        icon: 'check',
        paragraph: 'Online-Kundenportal verfügbar',
      },
      {
        icon: 'check',
        paragraph: 'Schneller und einfacher Wechsel',
      },
    ],
  },
};

export const WithoutHeadlineAndSvgIconsDark: Story = {
  args: {
    headline: '',
    useRoundIcon: false,
    listTag: 'ul',
    itemTheme: 'dark',
    items: [
      {
        icon: 'check',
        paragraph: 'Keine versteckten Kosten oder Gebühren',
      },
      {
        icon: 'check',
        paragraph: 'Flexible Vertragslaufzeiten',
      },
      {
        icon: 'check',
        paragraph: 'Online-Kundenportal verfügbar',
      },
      {
        icon: 'check',
        paragraph: 'Schneller und einfacher Wechsel',
      },
    ],
  },
};
